module.exports = __webpack_public_path__ + "assets/reference-periode.4cbcf4d7.svg";